var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"absolute right-0 top-0",attrs:{"max-width":"400px","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"absolute right-0",class:_vm.icon_class,attrs:{"color":_vm.icon_color,"dark":""}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t(("" + _vm.text))))])])}
var staticRenderFns = []

export { render, staticRenderFns }